module.exports = __webpack_public_path__ + "static/media/accounts_employees.81f50051.svg";